import { memo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import parseTimeDuration from "src/helpers/parseTimeDuration";
import { radiusSmall } from "src/styles/radius";
import { paddingMedium } from "src/styles/spacing";
import { BlurView, Text } from "src/swsh-native";

const VideoDurationDisplay = ({
	duration,
	style,
}: {
	duration: number;
	style?: StyleProp<ViewStyle>;
}) => {
	return (
		<BlurView
			pointerEvents="none"
			style={[
				style,
				{
					paddingVertical: paddingMedium,
					paddingHorizontal: paddingMedium,
					borderBottomLeftRadius: radiusSmall,
					overflow: "hidden",
				},
			]}
			testID="VideoDuration"
		>
			<Text small>{parseTimeDuration(duration)}</Text>
		</BlurView>
	);
};
export default memo(VideoDurationDisplay);
